module.exports = function getResource(label, vars = []) {
    const resources = {
        frequentlyBoughtTogether: 'Souvent achetés ensemble',
        addAllToBasket: 'Tout ajouter au panier',
        itemsAdded: 'Trois articles ajoutés : ',
        totalPrice: `Prix total : ${vars[0]} $`
    };

    return resources[label];
};
